/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdBreadcrumbItemProps, TdBreadcrumbProps } from './type';

export const breadcrumbDefaultProps: TdBreadcrumbProps = { maxItemWidth: undefined };

export const breadcrumbItemDefaultProps: TdBreadcrumbItemProps = {
  maxWidth: undefined,
  replace: false,
  target: '_self',
};
